<template>
    <div class="row">
        <div class="form-group col-md-4">
            <label :for="'questionDropdown' + index ">{{
                    _t("Question")
                }}</label>
            <select v-model="question_id" class="form-control"
                    :id="'questionDropdown' + index">
                <option value="" selected>{{ _t("Select...") }}</option>
                <option v-for="question in questions" :key="question.id" :value="question.id">
                    {{ question.text }} ({{ _t(question.type) }})
                </option>
            </select>
        </div>
        <div class="form-group col-md-3">
            <label :for="'operatorDropdown' + index ">{{
                    _t("Operator")
                }}</label>
            <select
                v-model="operator"
                class="form-control"
                :id="'operatorDropdown' + index "
                :disabled="isAnswerQuestion(question_id)"
            >
                <option disabled value="" selected>{{ _t("Select...") }}</option>
                <option value="equals">
                    {{ _t("=") }}
                </option>
                <option value="less_than">{{ _t("<") }}</option>
                <option value="greater_than">{{ _t(">") }}</option>
            </select>
        </div>
        <div v-if="isAnswerDropdown(question_id)" class="form-group col-md-4">
            <label :for="'answerDropdown' + index">{{ _t("Answer") }}</label>
            <select v-model="selectedAnswers" class="form-control"
                    :id="'answerDropdown' + index"
                    :multiple="isMultiAnswer(question_id)">
                <option disabled value="" selected>{{ _t("Select...") }}</option>
                <option v-for="answer in getAnswers(question_id)" :key="answer.id"
                        :value="answer.id">{{ answer.text }}
                </option>
            </select>
        </div>
        <div v-else class="form-group col-md-4">
            <label :for="'answerInput' + index">{{ _t("Answer") }}</label>
            <input v-model="inputAnswer" type="text" class="form-control"
                   :id="'answerInput' + index">
        </div>

        <div class="row">
            <div class="form-group col-md-12" style="margin-left: 16px">
                <button :disabled="isSurveyActive" @click="addDefinition" class="btn btn-primary">
                    <i class="fa fa-plus"/>
                    {{ _t("Add question / answer combination") }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CreateRuleDefinition",
    props: ['ruleId', 'questions', 'index', 'isSurveyActive'],
    data() {
        return {
            question_id: "",
            operator: 'equals',
            selectedAnswers: [],
            inputAnswer: '',
        }
    },
    methods: {
        addDefinition() {
            if(!this.question_id || !(this.selectedAnswers.length !== 0 || this.inputAnswer !== ''))  {
                Swal.fire({
                    text: _t('Question and answer fields are required'),
                    icon: "error",
                    duration: '1000'
                })
                return;
            }

            this.$emit('add-rule-definition', {
                ruleId: this.ruleId,
                ruleDefinition: {
                    question_id: this.question_id,
                    operator: this.operator,
                    selectedAnswers: this.selectedAnswers,
                    inputAnswer: this.inputAnswer
                }
            })

            this.question_id = ""
            this.operator = 'equals';
            this.selectedAnswers = [];
            this.inputAnswer = ''
        },
        getAnswers(questionId) {
            const selectedQuestion = this.questions.find(q => q.id === questionId);

            return selectedQuestion ? selectedQuestion.answers : [];
        },
        isAnswerQuestion(questionId) {
            const selectedQuestion = this.questions.find(q => q.id === questionId);

            const isAnswerQuestion = selectedQuestion && (selectedQuestion.type === 'single_answer' || selectedQuestion.type === 'multi_answer');

            if (isAnswerQuestion) {
                this.operator = 'equals'
            }

            return isAnswerQuestion;
        },
        isMultiAnswer(questionId) {
            const selectedQuestion = this.questions.find(q => q.id === questionId);
            return selectedQuestion && selectedQuestion.type === 'multi_answer';
        },
        isAnswerDropdown(questionId) {
            const selectedQuestion = this.questions.find(q => q.id === questionId);
            const isDropdown = selectedQuestion && (selectedQuestion.type === 'single_answer' || selectedQuestion.type === 'multi_answer');

            return isDropdown;
        },
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/app/components/CreateRuleDefinition.vue